import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: true,
};

export const myreportSlice = createSlice({
  name: "display",
  initialState,
  reducers: {
    makeVisible: (state) => {
      state.visible = !state.visible;
    },
  },
});

export const { makeVisible } = myreportSlice.actions;
export default myreportSlice.reducer;
